// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Authorities_establishments__2Qy05","header":"Authorities_header__1GQhe","tableHeader":"Authorities_tableHeader__3ofgY"};